
export const formatDate = (date: Date | string): string => {
    if (!date) {
      return '';
    }
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) {
      return '';
    }
    const formatted = dateObj.toLocaleDateString('en-CA'); // Format as YYYY-MM-DD
    return formatted;
  }